/* eslint-disable import/prefer-default-export */
import getFrontConfig from '../getFrontConfig';

const mapCountriesConfig = require('../../../../../config/mapCountriesConfig.json');

/** Gets the custom default coordinates for a certain countryCode to be used in the search
 * This function is needed for imaginary countries like IC, which have the same countryCode as others
 * @param  {string} countryCode - The country code to search for custom coordinates
 * @returns {string} The custom coordinates to be used in the search
 */
function getDefaultCustomCoordinates(countryCode) {
  return mapCountriesConfig[countryCode]?.defaultCoords;
}

/** Gets the custom default search radius for a certain countryCode to be used in the search
 * This function is needed for imaginary countries like IC, which have the same countryCode as others,
 * in order to delimint results to its own stores
 * @param  {string} countryCode - The country code to search for custom radius
 * @returns {number} The custom radius to be used in the search
 */
function getDefaultCustomSearchRadius(countryCode) {
  return mapCountriesConfig[countryCode]?.defaultRadius;
}

/** Parse the received country code for the country code to be used in the search
 * This function is needed for imaginary countries like IC,
 * which needs to search for stores in the ES country instead of the locale.country AD
 * @param  {string} countryCode - The country code expected to parse
 * @returns {string} The country code to be used in the search
 */
function parseCountryCode(countryCode) {
  return mapCountriesConfig[countryCode]?.countryCode || countryCode;
}

/**
 * Parse date to locale format
 * @param {string|number} useDate
 * @return {string} date locale format
 */
const parseDateByRegionFormat = (useDate = null) => {
  if (!useDate) return '';

  const {
    countryCode,
    currentLanguageCode,
  } = getFrontConfig();

  const formattedDate = new Date(useDate);
  const locale = `${currentLanguageCode}-${countryCode}`;

  try {
    return formattedDate.toLocaleDateString(locale);
  } catch {
    return formattedDate.toLocaleDateString();
  }
};

/**
 * Returns true if the localeCountryID belongs to a multicountry site
 * @param {string} localeCountryID - Locale country ID. P.E. ES, FR, AT, AD, KP, SG, etc.
 * @returns {boolean} true if the localeCountryID belongs to a multicountry site, false otherwise
 */
function doesLocaleCountryBelongToMulticountrySite(localeCountryID) {
  return localeCountryID === 'AT' // AT is the locale for the byl-eu Site
    || localeCountryID === 'KP'; // KP is the locale for the byl-ww Site
}

export {
  getDefaultCustomCoordinates,
  getDefaultCustomSearchRadius,
  doesLocaleCountryBelongToMulticountrySite,
  parseCountryCode,
  parseDateByRegionFormat,
};
